export enum HowToPayEnum {
  CARD = 'card',
  BANK_TRANSFER = 'bankTransfer',
  CASH_ON_ACCOUNT = 'cashOnAccount',
  FUTURE_SALES = 'futureSales',
  CHARGE_AND_SAVE_CARD = 'chargeAndSaveCard',
  CARD_ON_FILE = 'cardOnFile',
  NEW_CARD = 'newCard',
  PAYMENT_LINK = 'paymentLink',
}
